import { GridContainer } from 'libs/ui';
import { BenefitType } from 'grids/benefit-type/benefit-type';

export const BenefitTypeWrapper = (props) => {
  return (
    <GridContainer>
      <BenefitType {...props} />
    </GridContainer>
  );
};
